// utils/authFlags.js
import secureLocalStorage from "react-secure-storage";

export const setPartnerVerifiedFlag = (value) => {
  const v = !!value;

  secureLocalStorage.setItem("partnerVerified", v);

  // notify same-tab React components (storage event won't fire in same tab)
  window.dispatchEvent(new Event("authUpdate"));
};

export const readPartnerVerifiedFlag = () => {
  let raw = secureLocalStorage.getItem("partnerVerified");

  if (raw === true || raw === "1" || raw === "true") return true;
  if (raw === false || raw === "0" || raw === "false") return false;

  return false;
};